export const ROLES = {
  ADMIN: 1,
  HR: 2,
  SENIOR: 3,
};

export const adminOrHrRoles = [ROLES.ADMIN, ROLES.HR, ROLES.SENIOR];
export const hrOnlyRoles = [ROLES.HR];
